import React, { useState, useRef } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

type CollapseProps = {
  children: React.ReactNode;
  title: string;
  open?: boolean;
};

export const Collapse = ({ children, title, open = false }: CollapseProps) => {
  const [isOpen, setIsOpen] = useState(open);
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="w-full !h-full">
      <div
        className="flex justify-between items-center  cursor-pointer  w-full"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-[16px] font-[600]">{title}</h3>
        <span className="vi-glass-button w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0">
          {isOpen ? (
            <FaChevronUp className="w-3.5 h-3.5" />
          ) : (
            <FaChevronDown className="w-3.5 h-3.5" />
          )}
        </span>
      </div>

      <div
        ref={contentRef}
        style={{
          maxHeight: isOpen ? `1200px` : "0px",
          overflow: "hidden",
          transition: "max-height 0.3s ease",
        }}
        className="bg-white w-full !h-full mt-[10px] "
      >
        {children}
      </div>
    </div>
  );
};
